module.exports = "<div ng-class=\"{\n    container: !$$setting.data.general.checkboxs.largeMode.model,\n    largeContainer: $$setting.data.general.checkboxs.largeMode.model\n  }\"\n  class=\"page-view has-bottom-menu-1\">\n  <my-radio-menu my-menu=\"maneuverMenu\"\n    my-id=\"maneuver\">\n  </my-radio-menu>\n\n  <div class=\"line-separator\"></div>\n\n  <div ui-view>\n  </div>\n\n  <div class=\"bottom-menu\">\n    <div class=\"line-separator\"></div>\n    <my-radio-menu my-menu=\"maneuverMenu\"\n      my-id=\"maneuver\">\n    </my-radio-menu>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/maneuver/templates/index.html
// module id = 1612
// module chunks = 0